<template>
  <am-menu-anchor>
    <div class="am-phone">
      <div class="am-phone--flag" @click="onOpenCountries">
        <am-flag :country="regionCode" />
        <am-icon icon="arrow_drop_down" />
      </div>
      <am-text-field
        v-bind="$attrs"
        :label="label"
        :disabled="disabled"
        :placeholder="placeholder"
        :value="phoneNumber"
        :errorText="errorText"
        ref="textfield"
        @blur="$emit('blur', $event)"
        @input="onChange"
      />
    </div>
    <am-menu
      anchorCorner="TOP_START"
      defaultFocusState="LIST_ROOT"
      v-model="isOpenCountry"
      @selected="onSelectCountry"
      @keydown.native="onSearchCountry"
      ref="menu"
      :isHoisted="isHoisted"
      :fixed="fixed"
    >
      <am-list dense>
        <am-list-item
          v-for="country in countries"
          :key="country[1]"
          class="am-phone--list-item"
          :activated="country[1] === regionCode"
        >
          <template name="graphic">
            <am-flag :country="country[1]" />
          </template>
          <template name="text">
            <span class="am-phone--country-name">{{ country[0] }}</span>
            <span class="am-phone--country-code">+{{ country[2] }}</span>
          </template>
        </am-list-item>
      </am-list>
    </am-menu>
  </am-menu-anchor>
</template>

<script>
import { parsePhoneNumber, getCountryCodeForRegionCode } from "awesome-phonenumber";
import { AmTextField } from "../TextField";
import { AmIcon } from "../Icon";
import { AmFlag } from "../Flag";
import { AmList, AmListItem } from "../List";
import { AmMenu, AmMenuAnchor } from "../Menu";
import { countries } from "./countries";

export default {
  model: {
    prop: "value",
    event: "model"
  },
  inheritAttrs: false,
  components: {
    AmTextField,
    AmIcon,
    AmFlag,
    AmMenu,
    AmList,
    AmListItem,
    AmMenuAnchor
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    /**
     * Validation error text
     */
    errorText: {
      type: String,
      default: ""
    },
    /**
     * Sets whether the menu surface has been hoisted to the body so that the offsets are calculated relative to the page and not the anchor.
     */
    isHoisted: {
      type: Boolean,
      default: false
    },
    /**
     * Sets menu surface to fixed position relative to element.
     */
    fixed: {
      type: Boolean,
      default: false
    },
    /**
     * Two-letters country code in ISO 3166-1 alpha-2, officially assigned: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
     */
    country: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      countries,
      searchText: "",
      searchTimeout: null,
      isOpenCountry: false
    };
  },
  mounted() {
    if (!this.value && this.country) {
      const code = getCountryCodeForRegionCode(this.country);

      this.$emit("model", `+${code} `);
    }
  },
  computed: {
    regionCode() {
      if (!this.value) {
        return "";
      }

      const { regionCode } = parsePhoneNumber(this.value + "  ");

      return `${regionCode}`.toLowerCase();
    },
    phoneNumber() {
      if (!this.value) {
        return "";
      }
      const { number } = parsePhoneNumber(this.value);

      return number.international || number.input;
    }
  },
  watch: {
    searchText(value) {
      if (!value) {
        return;
      }

      const search = value.toLowerCase();
      const selectedIndex = this.countries.findIndex(
        ([country, , code]) => country.toLowerCase().indexOf(search) === 0 || code.toLowerCase().indexOf(search) === 0
      );

      if (selectedIndex > -1) {
        this.$refs.menu.mdcMenu.items[selectedIndex].focus();
      }

      clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => {
        this.searchText = "";
      }, 1000);
    }
  },
  methods: {
    onChange(e) {
      const value = `${e.target.value}`;
      const phoneValue = value.indexOf("+") !== -1 ? value : `+${value}`;
      const { number } = parsePhoneNumber(phoneValue);

      this.$emit("model", number.e164 || number.input);
    },
    onOpenCountries() {
      if (!this.disabled) {
        this.isOpenCountry = true;
      }
    },
    onSelectCountry({ index }) {
      this.$refs.textfield.$el.querySelector("input").focus();

      /**
       * Change phone number
       * @type {String}
       */
      this.$emit("model", "+" + this.countries[index][2] + " ");
    },
    onSearchCountry(e) {
      this.searchText = `${this.searchText}${e.key}`;
    }
  }
};
</script>
